import { QdzElement, adoptSectionStyles, define, loadModules, parseHTML, quickBuyStyle } from '@qdz/element';

export class QdzQuickView extends QdzElement {
  #controller = null;
  #opener = null;

  get dialog() {
    return this.closest('qdz-dialog');
  }

  mount() {
    this.listen(document, 'click', (event) => {
      const trigger = event.target.closest('[data-qdz-quick-add]');
      if (!trigger || quickBuyStyle(trigger) !== 'popup') return;
      event.preventDefault();
      this.#opener = trigger;
      this.load(trigger.dataset.qdzQuickAdd);
    });
  }

  unmount() {
    this.#controller?.abort();
  }

  async load(productUrl) {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', this.getAttribute('section-id'));
    this.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: this.#controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const doc = parseHTML(await response.text());
      const fresh = doc.querySelector('[data-qdz-quick-view-content]');
      if (!fresh) throw new Error('missing');
      adoptSectionStyles(doc);
      await loadModules(fresh);
      this.replaceChildren(fresh);
      if (!this.dialog?.isOpen) this.dialog?.open(this.#opener);
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(productUrl);
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

define('qdz-quick-view', QdzQuickView);
